var $1ae0a5dddbe03f83$exports = {};
$1ae0a5dddbe03f83$exports = {
    "info": `Inform\xe1cie`,
    "negative": `Chyba`,
    "positive": `\xdaspech`
};


export {$1ae0a5dddbe03f83$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
